module.exports = __webpack_public_path__ + "static/media/uk-flag.d770726c.png";